export const SELECTION_LEFT_STICKY_COLUMN = 'selection-left-sticky-column';

export const DATASET_LABEL_CREATE = 'dataset-label-create';
